<template>
  <div class="mt-2">
    <v-tabs
      align-with-title
    >
      <v-tabs-slider color="accent"></v-tabs-slider>
      <v-tab
        :to="{ name: 'Tax - Payments - Check Reconciliation' }"
        id="taxpaymentcheckreconciliation"
        class="input-text-size"
      >
      Check Reconciliation
      </v-tab>
      <v-tab
        :to="{ name: 'Tax - Payments - Posting Period' }"
        id="taxpaymentpostingperiod"
        class="input-text-size"
      >
      Posting Period
      </v-tab>
      <v-tab
        :to="{ name: 'Tax - Payments - Overpayments & Refunds' }"
        id="overpayments"
        class="input-text-size"
      >
      Overpayments & Refunds
      </v-tab>
      <v-tab
        :to="{ name: 'Tax - Payments - Create New Fiscal Year' }"
        id="createnewfiscalyear"
        class="input-text-size"
      >
      Create New Fiscal Year
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import '../../../../assets/style.css';

export default {
  name: 'TaxPaymentUtils',
  components: {
  },
};
</script>
